import { render, staticRenderFns } from "./selectRecAddr.vue?vue&type=template&id=39452d6e&scoped=true&"
import script from "./selectRecAddr.vue?vue&type=script&lang=js&"
export * from "./selectRecAddr.vue?vue&type=script&lang=js&"
import style0 from "./selectRecAddr.vue?vue&type=style&index=0&id=39452d6e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39452d6e",
  null
  
)

export default component.exports